(function () {
    'use strict';
    angular.module('Services').factory('JobsBatchTable', JobsBatchTable);

    JobsBatchTable.$inject = [
        'FleetService',
        'TableLiteFactory',
        'toastr',
        '$location',
        'TypeStatusConsts',
        '$uibModal',
        'Units',
        '$rootScope',
        '$filter',
        'ConfirmationModalFactory'
    ];

    function JobsBatchTable(
        FleetService,
        TableLiteFactory,
        toastr,
        $location,
        TypeStatusConsts,
        $uibModal,
        Units,
        $rootScope,
        $filter,
        ConfirmationModalFactory
    ) {
        return function (params = {}) {
            const {jobType, jobTypeValue, jobStatuses, jobStatusesValue} = TypeStatusConsts;
            let areaFilter,
                routeFilter;
            let viewConfirmation = new ConfirmationModalFactory({}, {
                    message: 'messages.warning.archive.MESSAGE',
                    code: 'messages.warning.archive.CODE',
                });
            let tableData = {
                tableName: 'FJobBatchTable',
                optionAddOns: {
                    buttons:[
                        {
                            class: 'btn-success',
                            label: 'ARCHIVE',
                            onClick:()=>{
                                const vm = this;
                                const selectedForArchiveJobs = tableData.data.filter(job => job.isSelected === true);
                                if(!selectedForArchiveJobs.length){
                                    toastr.warning('No jobs selected to move in archives.');
                                    return;
                                }
                                vm.disabled = true;
                                viewConfirmation.getInstance().result.then(function (cond) {
                                    if(cond){
                                        FleetService.Jobs.moveToArchiveJobBatch(selectedForArchiveJobs.map(job => job.batchId),
                                        res=>{
                                            toastr.success('Successfully move jobs to the archives.');
                                            tableActions.sendRequest({});
                                            vm.disabled = false;
                                        },
                                        err=>{
                                            toastr.error(err.message,err.code);
                                        })
                                    }
                                });
                            },
                            
                        }
                    ],
                    selectFilters: [
                        {
                            label: 'Area Filter',
                            ngModel: {label: 'N/A'},
                            width: '150px',
                            dropDownIsFetching: false,
                            selectChoices: [],
                            getChoicesData: function (search) {
                                this.dropDownIsFetching = true;
                                FleetService.Areas.getAll(data => {
                                    this.selectChoices = data.content.map(item => {
                                        return {
                                            label: item.areaId,
                                            areaName: item.areaId
                                        }
                                    });
                                    this.selectChoices.push({
                                        label: 'N/A',
                                        areaName: ''
                                    });

                                    this.dropDownIsFetching = false;
                                }, error => {
                                    this.dropDownIsFetching = false;
                                    toastr.error("Error", error.message);
                                }, {
                                    areaId: search
                                });
                            },
                            onSelect: function (selected) {
                                const filter = {
                                    filter: {type: 'text', model: selected.areaName},
                                    filterName: "areaName",
                                }
                                areaFilter = selected.areaName;
                                tableData.headers.push(filter);
                                tableActions.sendRequest(tableActions.evaluateFilter(filter));
                            }
                        },
                        {
                            label: 'Route Filter',
                            ngModel: {label: 'N/A'},
                            width: '150px',
                            dropDownIsFetching: false,
                            selectChoices: [],
                            getChoicesData: function (search) {
                                this.dropDownIsFetching = true;
                                FleetService.Routes.getRoutes(data => {
                                    this.dropDownIsFetching = false;
                                    this.selectChoices = data.content.map(item => {
                                        return {
                                            label: item.name,
                                            routeName: item.name
                                        }
                                    });

                                    this.selectChoices.push({
                                        label: 'N/A',
                                        routeName: ''
                                    });
                                }, error => {
                                    this.dropDownIsFetching = false;
                                    toastr.error("Error", error.message);
                                }, {
                                    name: search
                                });
                            },
                            onSelect: function (selected) {
                                const filter = {
                                    filter: {type: 'text', model: selected.routeName},
                                    filterName: "routeName",
                                }
                                routeFilter = selected.routeName;
                                tableData.headers.push(filter);
                                tableActions.sendRequest(tableActions.evaluateFilter(filter));
                            }
                        }
                    ]
                },
                config: {
                    noPagination: false,
                    noHeaders: false,
                    noItemsView: false,
                    noTableFooter: false
                },
                headers: [{
                    label: 'SELECT',
                    class: 'text-center',
                    filter: {
                        type: 'checkbox'
                    }
                    },{
                        label: 'SCHEDULED PICK-UP',
                        viewName: 'scheduledPickup',
                        filterName: 'scheduledPickup',
                        filter: {
                            type: 'datePicker',
                            url: '',
                            class: 'filter-date',
                            toModel: params.scheduledPickUp ? new Date(params.scheduledPickUp[0]) : '',
                            fromModel: params.scheduledPickUp ? new Date(params.scheduledPickUp[1]) : '',
                            useArray: true,
                            onSubmit: function (header) {
                                tableActions.sendRequest(tableActions.evaluateFilter(header));
                            }
                        },
                        headerFn: function () {
                            tableActions.sort(this.filterName);
                        }
                    }, {
                        label: 'BATCH ID',
                        viewName: 'batchId',
                        filterName: 'batchId',
                        filter: {
                            type: 'text',
                            onSubmit: function (header) {
                                console.log(header);
                                tableActions.sendRequest(tableActions.evaluateFilter(header));
                            }
                        },
                        headerFn: function () {
                            tableActions.sort(this.filterName);
                        }
                    },
                    {
                        label: 'SORT CODES',
                        viewName: 'sortCodesData',
                        filterName: 'route.area.sortCode',
                        filter: {
                            type: 'text',
                            onSubmit: function (header) {
                                tableActions.sendRequest(tableActions.evaluateFilter(header));
                            }
                        },
                        headerFn: function () {
                            tableActions.sort(this.filterName);
                        }
                    },
                    {
                        label: 'COMPANY',
                        viewName: 'company',
                        filterName: 'companyName',
                        filter: {
                            type: 'text',
                            onSubmit: function (header) {
                                tableActions.sendRequest(tableActions.evaluateFilter(header));
                            }
                        },
                        headerFn: function () {
                            tableActions.sort(this.filterName);
                        }
                    },
                    {
                        label: 'OFFICE LOCATION',
                        viewName: 'officeLocation',
                        filterName: 'officeName',
                        filter: {
                            type: 'text',
                            onSubmit: function (header) {
                                tableActions.sendRequest(tableActions.evaluateFilter(header));
                            }
                        },
                        headerFn: function () {
                            tableActions.sort(this.filterName);
                        }
                    }, {
                        label: 'TOTAL PACKAGES',
                        viewName: 'totalPackagesNumber',
                        filterName: 'totalPackagesNumber',
                        filter: {
                            type: 'text',
                            onSubmit: function (header) {
                                tableActions.sendRequest(tableActions.evaluateFilter(header));
                            }
                        },
                        headerFn: function () {
                            tableActions.sort(this.filterName);
                        }
                    },
                    {
                        label: 'TOTAL JOBS',
                        viewName: 'totalJobsNumber',
                        filterName: 'totalJobsNumber',
                        filter: {
                            type: 'text',
                            onSubmit: function (header) {
                                tableActions.sendRequest(tableActions.evaluateFilter(header));
                            }
                        },
                        headerFn: function () {
                            tableActions.sort(this.filterName);
                        }
                    }, 
                    {
                        label: 'MANIFEST NUMBER',
                        viewName: 'manifestNumber',
                        filterName: 'manifestNumber',
                        filter: {
                            type: 'text',
                            onSubmit: function (header) {
                                tableActions.sendRequest(tableActions.evaluateFilter(header));
                            }
                        },
                        headerFn: function () {
                            tableActions.sort(this.filterName);
                        }
                    }, {
                        label: 'TOTAL PACKAGES\' CUBIC WEIGHT',
                        viewName: 'totalPackagesCubicWeightFormatted',
                        filterName: 'totalPackagesCubicWeight',
                        filter: {
                            type: 'text',
                            onSubmit: function (header) {
                                tableActions.sendRequest(tableActions.evaluateFilter(header));
                            }
                        },
                        headerFn: function () {
                            tableActions.sort(this.filterName);
                        }
                    },{
                        label: 'TOTAL PACKAGES WEIGHT',
                        viewName: 'totalPackagesWeightFormatted',
                    }],
                data: [],
                extractTable: function (form) {

                },
                resetFilters: () => {
                    tableActions.resetFilters();
                },
                rowOnClick: batch => showBatchJobs(batch),
                onInit: function () {
                    tableActions.sendRequest({});
                }
            };
            const tableActions = new TableLiteFactory(tableData,
                {
                    serviceCallback: FleetService.Jobs.getAllJobBatches,
                    callbackFormat: ['success', 'error', 'filter'],
                    postRequestCallback: data => {
                        buildTableData(data);
                    },
                    postRequestErrorCallback: err => {
                        buildTableData(null);
                        toastr.error(err);
                    },
                    paramId: angular.getObjVal(params, 'area.id'),
                    defaultFilters: angular.extend({
                        size: 20,
                        page: 0,
                        sort: 'batchId,desc',
                        'route.id': angular.getObjVal(params, 'route.id'),
                    }, params.filters || {})
                }
            );

            function buildTableData(data) {
                /*** START - Building of Data ***/
                if (!data)
                    return tableData;
                tableActions.initializeTableData(data);
                angular.forEach(data.content, function (item) {
                    item.company = {
                        type: 'multiLine',
                        list: item.companyNames.length != 0 ? item.companyNames : ['N/A']
                    }
                    item.officeLocation = {
                        type: 'multiLine',
                        list: item.officeNames.length != 0 ? item.officeNames : ['N/A']
                    }
                    item.scheduledPickup = {
                        type: 'multiLine',
                        list: item.pickupDetails.length != 0 ? item.pickupDetails.map(data => {
                            return $filter('bbaDate')(data.pickupDate, true);
                        }) : ['N/A']
                    };
                    const weightUnit = Units.getWeightUnit($rootScope.GlobalProfile.office.weightUnit);
                    item.totalPackagesCubicWeightFormatted = `${item.totalPackagesCubicWeight} ${weightUnit}`;
                    item.totalPackagesWeightFormatted = item.totalPackagesWeight ? `${item.totalPackagesWeight} ${weightUnit}` : 'N/A';

                    const sortCodes = item.sortCodes.filter(code => code);
                    item.sortCodesData = {
                        type: 'multiLine',
                        list: sortCodes.length > 0 ? sortCodes : ['N/A'],
                    };
                    tableData.data.push(item);
                });
            }

            function showBatchJobs(batch) {
                $uibModal.open({
                    animation: true,
                    ariaLabelledBy: 'modal-title',
                    ariaDescribedBy: 'modal-body',
                    templateUrl: '/templates/pages/jobs/add-ons/batchJobsModal.html',
                    controller: function (JobsTableService, $uibModalInstance) {
                        const vm = this;
                        vm.batch = batch;
                        vm.jobsListData = new JobsTableService({
                            filters: {
                                batchId: batch.batchId,
                                areaName: areaFilter,
                                routeName: routeFilter,
                                is_archived:false
                            }
                        }, true).tableData;
                        vm.dismiss = dismiss;

                        function dismiss() {
                            $uibModalInstance.dismiss();
                        }
                    },
                    controllerAs: 'vm',
                    windowClass: 'full-height-modal batch-job-modal',
                    size: 'lg',
                    appendTo: $('body')
                });
            }

            this.tableData = tableData;
        }
    }
})();



// WEBPACK FOOTER //
// ./js/services/tables/jobsTable/JobsBatchTable.js